export const PartnerType = Object.freeze({
  new: 'new',
  silver: 'silver',
  gold: 'gold',
  founder: 'founder',
  starter: 'starter',
  light: 'light',
  partner1: 'partner-1',
  partner2: 'partner-2',
  partner3: 'partner-3',
  pro1: 'pro-1',
  pro2: 'pro-2',
  pro3: 'pro-3',
  pro4: 'pro-4',
  pro5: 'pro-5',
  enterprise1: 'enterprise-1',
  enterprise2: 'enterprise-2',
  enterprise3: 'enterprise-3',
  enterprise4: 'enterprise-4',
  enterprise5: 'enterprise-5',
});

export const PartnerTypeLabel = Object.freeze({
  [PartnerType.new]: 'New',
  [PartnerType.silver]: 'Silver',
  [PartnerType.gold]: 'Gold',
  [PartnerType.light]: 'Light',
  [PartnerType.starter]: 'Starter',
  [PartnerType.founder]: 'Founding Partner',
  [PartnerType.partner1]: 'Partner',
  [PartnerType.partner2]: 'Partner',
  [PartnerType.partner3]: 'Partner',
  [PartnerType.pro1]: 'Professional',
  [PartnerType.pro2]: 'Professional',
  [PartnerType.pro3]: 'Professional',
  [PartnerType.pro4]: 'Professional',
  [PartnerType.pro5]: 'Professional',
  [PartnerType.enterprise1]: 'Enterprise',
  [PartnerType.enterprise2]: 'Enterprise',
  [PartnerType.enterprise3]: 'Enterprise',
  [PartnerType.enterprise4]: 'Enterprise',
  [PartnerType.enterprise5]: 'Enterprise',
});

export function isValid(type) {
  return Object.values(PartnerType).find((elem) => elem === type);
}

export function toLabel(type) {
  if (!isValid(type)) {
    return '';
  }

  return PartnerTypeLabel[type];
}

export function isLegacyPartner(type) {
  switch (type) {
    case PartnerType.new:
    case PartnerType.silver:
    case PartnerType.gold:
      return true;
    default:
      return false;
  }
}

export function isLight(type) {
  return type === PartnerType.light;
}

export function isStarter(type) {
  return type === PartnerType.starter;
}

export function isPartner(type) {
  switch (type) {
    case PartnerType.partner1:
    case PartnerType.partner2:
    case PartnerType.partner3:
      return true;
    default:
      return false;
  }
}

export function isPro(type) {
  switch (type) {
    case PartnerType.pro1:
    case PartnerType.pro2:
    case PartnerType.pro3:
    case PartnerType.pro4:
    case PartnerType.pro5:
      return true;
    default:
      return false;
  }
}

export function isEnterprise(type) {
  switch (type) {
    case PartnerType.enterprise1:
    case PartnerType.enterprise2:
    case PartnerType.enterprise3:
    case PartnerType.enterprise4:
    case PartnerType.enterprise5:
      return true;
    default:
      return false;
  }
}

export const isPremium = (type) =>
  isPro(type) || isEnterprise(type) || isPartner(type) || PartnerType.founder === type;
